<template>
    <div class="bg">
        <div class="main">
            <div class="logo"><img src="../../static/img/register/logo.png" alt="注册"></div>
            <div class="title">用户注册</div>
            <el-radio v-model="registerType" label="1">个人</el-radio>
            <el-radio v-model="registerType" label="2">企业</el-radio>
            <div class="form" >
                <el-form :validate-on-rule-change="false" v-if="registerType==='1'" :rules="userRules" ref="user"  :model="user" label-width="100px" label-position="left">
                        <el-form-item label="手机号:" prop="phoneNumber" style="text-align: left;">
                            <el-input  v-model="user.phoneNumber" style="width:calc(100% - 120px)"></el-input>
                            <!--<el-button :disabled="btnDisable" type="primary" style="width:90px;float: right" @click="getCode(user.phoneNumber,'1')">{{btnText}}</el-button>-->
                        </el-form-item>
                        <!--<el-form-item label="验证码:" prop="code">
                            <el-input  v-model="user.code"></el-input>
                        </el-form-item>-->
                        <el-form-item label="密码:" prop="credentials" >
                            <el-input v-model="user.credentials" type="password"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码:" prop="credentials2">
                            <el-input v-model="user.credentials2" type="password"></el-input>
                        </el-form-item>
                </el-form>
                <el-form :validate-on-rule-change="false" v-if="registerType==='2'" :rules="companyRules" ref="company"  :model="company" label-width="100px" label-position="left">
                    <el-form-item label="手机号:" prop="phoneNumber" style="text-align: left;">
                        <el-input  v-model="company.phoneNumber" style="width:calc(100% - 120px)"></el-input>
                        <!--<el-button type="primary" style="width:90px;float: right" @click="getCode(company.phoneNumber,'2')">{{btnText}}</el-button>-->
                    </el-form-item>
                    <!--<el-form-item label="验证码:" prop="code" style="text-align: left;">
                        <el-input  v-model="company.code"></el-input>
                    </el-form-item>-->
                    <el-form-item label="企业注册号:" prop="enterprise.registerNo">
                        <el-input  v-model="company.enterprise.registerNo"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:" prop="credentials" >
                        <el-input v-model="company.credentials" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" prop="credentials2">
                        <el-input v-model="company.credentials2" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="企业名:" prop="enterprise.name" >
                        <el-input v-model="company.enterprise.name"></el-input>
                    </el-form-item>
                    <el-form-item label="企业编号:" prop="enterprise.code">
                        <el-input v-model="company.enterprise.code"></el-input>
                    </el-form-item>
                </el-form>
                <div class="register-btn">
                    <button class="register" @click="register">注册</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Register",
        data() {
            let validatePassword2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请确认密码'));
                } else if (value !== this.user.credentials) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            let validateCompanyPassword2=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请确认密码'));
                } else if (value !== this.company.credentials) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            //validatePhone
            let validatePhone=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请确认手机号'));
                } else if (!(/^1[3578]\d{9}$/.test(value))) {
                    callback(new Error('手机号码有误!'));
                } else {
                    callback();
                }
            };
            return {
                registerType:"1",
                user:{
                    phoneNumber:"",
                    credentials:"",
                    credentials2:"",
                    operatorId:""
                },
                company:{
                    phoneNumber:"",
                    credentials:"",
                    credentials2:"",
                    enterprise:{
                        registerNo:"",
                        name:"",
                        code:""
                    },
                    operatorId:""
                },
                btnText:"获取验证码",
                clock:60,
                btnDisable:false,
                userRules: {
                    phoneNumber: [
                        {validator:validatePhone, required: true, trigger: 'blur'},
                    ],
                    code: [
                        { required: true, message: '请输入验证码', trigger: 'blur'},
                    ],
                    credentials: [
                        { required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    credentials2: [
                        { validator:validatePassword2, required: true, trigger: 'blur'},
                    ],
                },
                companyRules: {
                    phoneNumber: [
                        {validator:validatePhone, required: true, trigger: 'blur'},
                    ],
                    'enterprise.registerNo': [
                        { required: true, message: '请输入企业注册号', trigger: 'blur'},
                    ],
                    code: [
                        { required: true, message: '请输入验证码', trigger: 'blur'},
                    ],
                    credentials: [
                        { required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    credentials2: [
                        { validator:validateCompanyPassword2, required: true, trigger: 'blur'},
                    ],
                    'enterprise.name': [
                        { required: true, message: '请输入企业名', trigger: 'blur'},
                    ],
                    'enterprise.code': [
                        { required: true, message: '请输入企业编号', trigger: 'blur'},
                    ],
                },
            }
        },
        created() {
        },
        methods: {
            register(){
                switch (this.registerType) {
                    case "1":
                        this.$refs.user.validate((valid) => {
                            if(valid){
                                delete this.user.credentials2;
                                this.$json("/register","POST",this.user).then(()=>{
                                    this.$json("/login","POST",{phoneNumber:this.user.phoneNumber, credentials:this.user.credentials}).then(res=>{
                                        this.$store.dispatch("addToken",res.data.token);
                                        this.$store.dispatch("setMenuList",res.data.menuList);
                                        this.$router.replace("/Home");
                                    });
                                })
                            }
                        });
                        break;
                    case "2":
                        this.$refs.company.validate((valid) => {
                            if(valid){
                                delete this.company.credentials2;
                                this.$json("/register","POST",this.company).then(()=>{
                                    this.$json("/login","POST",{phoneNumber:this.company.phoneNumber, credentials:this.company.credentials}).then(res=>{
                                        this.$store.dispatch("addToken",res.data.token);
                                        this.$store.dispatch("setMenuList",res.data.menuList);
                                        this.$router.replace("/Home");
                                    });
                                })
                            }
                        });
                        break;
                }
            },
            time(){
                this.clock--;
                this.btnText = `${this.clock}秒后重试`;
                this.btnDisable = true;
                if(this.clock===0){
                    this.btnDisable = false;
                    this.btnText="获取验证码";
                    clearInterval(this.fct);
                    this.clock = 60;
                }
            },
            getCode(phone,type){
                this.time();
                this.fct = setInterval(this.time,1000);
                this.$json('/code/phone/'+phone,"GET",{}).then(res=>{
                    if(type==='1'){
                        this.user.operatorId = res.data;
                    }
                    else this.company.operatorId = res.data;
                });
            },
        },
        watch:{
            'registerType'(){
                if (this.$refs.user!==undefined) {
                    this.$refs.user.resetFields();
                }
                if(this.$refs.company!==undefined){
                    this.$refs.company.resetFields();
                }
            }
        }
    }
</script>

<style scoped lang="less">
    label{width:200px !important;}
    .bg {
        background-image: url("../../static/img/register/bg.png");
        background-position: center;
        background-size: 100%;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        .main {
            width: 660px;
            margin: auto;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 620px;
            .logo {
                padding: 10px 0;
                text-align: center;
                height:80px;
                img{height:80px;}
            }
            .title {
                color:#0258e3;
                border-bottom: 1px solid #0258e3;
                text-align:center;
                font-size:24px;
            }
            .form{
                margin-top:20px;
            }
        }
        .register-btn{
            width:100%;
            text-align: center;
            .register{
                width:100%;color:#fff;outline: 0;border:0;background-color: #0558e4;height:40px;
                line-height: 40px;border-radius: 5px;
                cursor: pointer;
                position: relative;}
            .register:active{
                top:1px;
                left:1px;
            }
        }


    }

    .el-select{width:100%;}
</style>
